
let slidesPerView = 3
const ScreenWidth = document.documentElement.clientWidth || window.innerWidth;
if (ScreenWidth <= 752) {
  slidesPerView = 1.5
}

var mySwiper = new Swiper ('#product-blogs-swiper', {
  direction: 'horizontal', // 垂直切换选项
  loop: false, // 循环模式选项
  slidesPerView: slidesPerView,
  spaceBetween: 12,
  
  // 如果需要分页器
  pagination: {
    el: '.swiper-pagination',
  },
  
  // 如果需要前进后退按钮
  navigation: {
    nextEl: '.product-blogs-swiper-button-next',
    prevEl: '.product-blogs-swiper-button-prev',
  },
  
  // 如果需要滚动条
  scrollbar: {
    el: '.swiper-scrollbar',
  },
}) 